import * as pjConf from '@/configuration/general/pieceJointeConf';
import { pGetAllPieceJointe } from '@/api/pieceJointes';

export default async function getPiecesJointeTypeByIds(data, type) {
  const validType = [
    pjConf.PIECE_JOINTE_TYPE_INSTRUCTION_POSE,
    pjConf.PIECE_JOINTE_TYPE_COMMANDE_SIGNEE_ELECTRONIQUEMENT,
  ];
  if (!Array.isArray(data) || !data.length || !validType.includes(type)) return;
  const elementsId = data.map(i => i.id);
  if (!elementsId.length) return;
  const allPiece = (await pGetAllPieceJointe({ elementsId })).data.result.items;
  data.forEach(m => {
    m.cheminMin = '';
    const piece = allPiece.find(p => p.elementId === m.id
      && (p.placeType === type || p.type?.libelle === type));
    if (!piece) return;
    m.cheminMin = piece.chemin || piece.cheminMin;
  });
}

export async function getPiecesJointeInstructionPoseByIds(data) {
  await getPiecesJointeTypeByIds(data, pjConf.PIECE_JOINTE_TYPE_INSTRUCTION_POSE);
}

export async function getPiecesJointeCommandeSignesByIds(data) {
  await getPiecesJointeTypeByIds(data, pjConf.PIECE_JOINTE_TYPE_COMMANDE_SIGNEE_ELECTRONIQUEMENT);
}
